<template>
	<v-dropdown
		:ref="setup._popover"
		:placement="placement"
		@apply-show="setup.handlePopoverShowAsync()"
		@apply-hide="setup.handlePopoverHide()">
		<slot>
			<o-icon
				ripple="info"
				font-icon="icon-interface-bookmark-tag"
				@click.stop/>
		</slot>

		<template #popper>
			<shared-flat-select
				v-model:search="setup.search"
				:show-search="setup.tags.length > 10"
				:loading="setup.loading"
				:value="setup.selectedTags"
				:partial="setup.partialTags"
				:options="setup.tagsListOptionsForFlatSelect"
				:selected-function="setup.tagIsSelected.bind(setup)"
				:partial-function="setup.tagIsPartiallySelected.bind(setup)"
				:new-label="hideNew ? undefined : $t('business.tags.newTag')"
				:popover-opened="setup.popoverOpened"
				@add="setup.linkAsync($event)"
				@delete="setup.unlinkAsync($event)"
				@new="setup.createTagAsync()">
				<template #default="{ item: tag }">
					<div class="tag-option swap-colors">
						<div
							class="tag-color"
							:class="`background--${tag.colorName}`"/>
						<span v-html="tag.name.mark(setup.search)"/>
					</div>
				</template>

				<template #empty>
					<o-alert
						color="info"
						center>
						{{ $t('business.tag.emptyState') }}
					</o-alert>
				</template>
			</shared-flat-select>
		</template>
	</v-dropdown>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedTagFlatSelectEmits, SharedTagFlatSelectProps } from './SharedTagFlatSelectSetup';
import SharedTagFlatSelectSetup from './SharedTagFlatSelectSetup';
const emits = defineEmits<SharedTagFlatSelectEmits>() as SharedTagFlatSelectEmits;
const props = withDefaults(defineProps<SharedTagFlatSelectProps>(), SharedTagFlatSelectSetup.defaultProps);
const setup = new SharedTagFlatSelectSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
.tag-color {
	width: 1rem;
	height: 1rem;
	border-radius: 0.25rem;
}

.tag-option {
	cursor: pointer;
	display: flex;
	gap: 0.5rem;
	align-items: center;
}

.v-popper {
	display: flex;
	align-items: center;
}
</style>
